import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FingerprintjsProAngularService } from '@fingerprintjs/fingerprintjs-pro-angular';
import { Router } from '@angular/router';
import { AlertComponent } from '../components/message/alert/alert.component';
import { MatDialog } from '@angular/material/dialog';
declare global {
  interface Navigator {
    msSaveBlob?: (blob: any, defaultName?: string) => boolean
  }
}

const domainUrl=environment.domainDetailUrl;
const AcsMFELoginBaseUrl = environment.acsMFEUrl;
// console.log('AcsMFELoginBaseUrl',AcsMFELoginBaseUrl)
@Injectable({
  providedIn: 'root'
})
export class RestService {
  customUrl!: string;
  currentPage: string = "Home";
  visitorId!: string;
  extendedResult: any;


  constructor(public http: HttpClient, public router:Router, private dialog:MatDialog) { }

  setBaseURL(url: any) {
    this.customUrl = url;
  }
  getUrl() {
    return this.customUrl;
  }





  acsMFEPostData<T>(data: T, url: string, headers?: any, loginUrl?: any): Observable<any> {
    if (loginUrl) {
      if (headers) {
        return this.http.post<any>(`${AcsMFELoginBaseUrl}` + url, data, { headers: headers })
          .pipe(map(response => {
            return response;
          }
          ));
      } else {
        return this.http.post<any>(`${AcsMFELoginBaseUrl}` + url, data)
          .pipe(map(response => {
            return response;
          }
          ));
      }
    } else {
      if (headers) {
        return this.http.post<any>(`${AcsMFELoginBaseUrl}` + url, data, { headers: headers })
          .pipe(map(response => {
            return response;
          }
          ));
      } else {
        return this.http.post<any>(`${AcsMFELoginBaseUrl}` + url, data)
          .pipe(map(response => {
            return response;
          }
          ));
      }
    }
  }


  public getPhoneCode(): Observable<any> {
    return this.http.get("./assets/SampleJson/phoneCode.json");
  }

  public getErrorMsg(): Observable<any> {
    return this.http.get("./assets/SampleJson/errorCode.json");
  }

 


  LogMeetingHistory(videoForm:any,eventType : number, eventComment : string,isMeetingEnded:boolean){
    let inputReq: any = {};
    inputReq.userMeetingID = videoForm.userId;
    inputReq.meetingID = videoForm.groupId;
    inputReq.eventType = eventType;
    inputReq.comment = eventComment;
    inputReq.isMeetingEnded = isMeetingEnded
    this.acsMFEPostData(inputReq, '/api/digital/core/Meeting/InsertMeetingHistory', null,'LoginUrl').subscribe((data: any) => {
      if (data.rcode == 200) {
        let responseData: any = data;
        
      } else if (data.rcode == 401) {
        this.router.navigate(['start-meeting']);
      } else if (data.rcode == 501) {}
      else if (data.rmsg && data.rmsg[0]?.errorCode == 'ERR018') {
        const dialogRef = this.dialog.open(AlertComponent, {
          width: '35vw',
          data: {
            data: 'We encountered a server issue. We will refresh the page for you to try again.',
            type: 'alert',
          },
        });
        dialogRef.afterClosed().subscribe((result : any) => {
          window.location.reload();
        });
      } 
      else {}
      },
        (err: any) => {
          this.router.navigate(['/start-meeting']);
        }
      );
  }

  logUserLeftAndReloadScreen(videoForm:any,eventType : number, eventComment : string,isMeetingEnded:boolean){
    let inputReq: any = {};
    inputReq.userMeetingID = videoForm.userId;
    inputReq.meetingID = videoForm.groupId;
    inputReq.eventType = eventType;
    inputReq.comment = eventComment;
    inputReq.isMeetingEnded = isMeetingEnded
    this.acsMFEPostData(inputReq, '/api/digital/core/Meeting/InsertMeetingHistory', null,'LoginUrl').subscribe((data: any) => {
      if (data.rcode == 200) {
        let responseData: any = data;
        const dialogRef = this.dialog.open(AlertComponent, {
          width: '35vw',
          data: {
            data: 'We encountered a server issue. We will refresh the page for you to try again.',
            type: 'alert',
          },
        });
        dialogRef.afterClosed().subscribe((result : any) => {
          window.location.reload();
        });
      } else if (data.rcode == 401) {
        this.router.navigate(['login']);
      } else if (data.rcode == 501) {}
      else if (data.rmsg && data.rmsg[0]?.errorCode == 'ERR018') {
        const dialogRef = this.dialog.open(AlertComponent, {
          width: '35vw',
          data: {
            data: 'We encountered a server issue. We will refresh the page for you to try again.',
            type: 'alert',
          },
        });
        dialogRef.afterClosed().subscribe((result : any) => {
          window.location.reload();
        });
      } 
      else {}
      },
        (err: any) => {
          this.router.navigate(['/start-meeting']);
        }
      );
  }


  getDomainDetails<T>(data: T, url: string, headers?: any, loginUrl?: any): Observable<any> {
    if (headers) {
      return this.http.post<any>(`${domainUrl}` + url, data, { headers: headers })
        .pipe(map(response => {
          return response;
        }
      ));
    } else {
      return this.http.post<any>(`${domainUrl}` + url, data)
        .pipe(map(response => {
          return response;
        }
      ));
    }
  }

}
